let url = process.env.REACT_APP_ADMIN_API

module.exports = {
    GetUsersList: `${url}api/admin/users`,
    ActionUser: `${url}api/admin/user`,
    GetNotify: `${url}api/admin/ddl/notificationTypes`,
    GetUsers: `${url}api/admin/ddl/users`,
    GetApplications: `${url}api/admin/applications`,
    ActionApplication: `${url}api/admin/application`,
    GetMasters: `${url}api/admin/masterdata/parent`,
    GetActionMasterData: `${url}api/admin/masterdata/`,
    GetDivisionCode: `${url}api/admin/ddl/divisioncode`,
    GetDepartmentCode: `${url}/api/admin/ddl/departmentcode`,
    GetCategoryCode: `${url}api/admin/ddl/categorycode`,
    GetLevel: `${url}api/admin/ddl/level`,
    GetDesignationName: `${url}api/admin/ddl/desginationname`,
    GetMainRole: `${url}api/admin/ddl/mainrole`,
    GetSupportingRole: `${url}api/admin/ddl/supportingrole`,
    ImportUsers: `${url}api/admin/user/import`,
    ExportUsers: `${url}api/admin/user/export`,
    VerifyEmail: `${url}api/admin/user/verifyValidMail`,
    TokenAuthenticate: `${url}api/admin/authenticate/token`,
    TokenInvalidate: `${url}api/admin/authenticate/invalidate-token`,
    VerifyApplication: `${url}api/admin/application/verify/`,
    VerifyUser: `${url}api/admin/user/verify`,
    verifyLeadChange: `${url}api/admin/user/leadchange/verify`,
}
